(function () {
  function applyInventoryUpdate(invEl, variantId) {
    var dataEl = invEl.querySelector('script.pw-inv-data');
    if (!dataEl) return;

    var variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var v = null;
    for (var i = 0; i < variants.length; i++) {
      // loose == handles numeric id vs string
      if (variants[i].id == variantId) {
        v = variants[i];
        break;
      }
    }
    if (!v) return;

    var icon = invEl.querySelector('.product-inventory__icon');
    if (icon) {
      var cls = (icon.getAttribute('class') || '').replace(/product-inventory__icon-\S+/g, '').trim();
      icon.setAttribute('class', cls + ' product-inventory__icon-' + v.status);
    }

    var textEl = invEl.querySelector('.product-inventory__text');
    if (textEl) textEl.textContent = v.text;

    invEl.classList.toggle('product-inventory--preorder', v.status === 'pre_order');
  }

  function initSection(section) {
    if (!section.querySelector('product-inventory')) return;
    // Guard against attaching twice (e.g. shopify:section:load in the editor).
    if (section.dataset.pwInvBound === '1') return;
    section.dataset.pwInvBound = '1';

    section.addEventListener('variant:update', function (e) {
      var resource = e.detail && e.detail.resource;
      if (!resource || !resource.id) return;
      // Re-query the live element on every update rather than caching it: a variant change can
      // morph/replace the <product-inventory> node, which would strand a cached reference and
      // leave the status stuck (e.g. selecting an in-stock size after an out-of-stock one not
      // resetting). Always target whatever <product-inventory> is currently in the DOM.
      var invEl = section.querySelector('product-inventory');
      if (invEl) applyInventoryUpdate(invEl, resource.id);
    });
  }

  document.querySelectorAll('.shopify-section').forEach(initSection);

  document.addEventListener('shopify:section:load', function (e) {
    initSection(e.target);
  });
})();
